import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { CHAUFFEUR_URL } from "../../settings/APISetting";
import { sortByProp } from "../../settings/themeSettings";
import api from "../../config/axiosConfig";



export const fetchChauffeur = createAsyncThunk('fetch-chauffeurs', async (page = 1) => {
    const response = await api.get(CHAUFFEUR_URL);
    return response.data;
});


export const createChauffeur = (chauffeur, err, cb) => {
    api.post(CHAUFFEUR_URL, chauffeur)
        .then((response) => {
            if (cb) cb(response.data);
        })
        .catch((error) => {
            if (err) err(error);
        });
}


export const updateChauffeur = (chauffeur, err, cb) => {
    api.put(`${CHAUFFEUR_URL}/${chauffeur.id}`, chauffeur)
        .then((response) => {
            if (cb) cb(response.data);
        })
        .catch((error) => {
            if (err) err(error);
        });
}


export const deleteChauffeur = (id, err, cb) => {
    api.delete(`${CHAUFFEUR_URL}/${id}`)
        .then((response) => {
            if (cb) cb(response);
        })
        .catch((error) => {
            if (err) err(error);
        });
}



const chauffeurSlice = createSlice({

    name: 'chauffeurs',
    initialState: { chauffeurs: [], chauffeursFetchStatus: '' },

    reducers: {
        addChauffeur: (state, action) => {
            state.chauffeurs = [...state.chauffeurs, action.payload].sort((a,b) => sortByProp(a,b,'nomComplet'));
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchChauffeur.fulfilled, (state, action) => {
            if (Array.isArray(action.payload)) {
                state.chauffeurs = [...action.payload].sort((a, b) => sortByProp(a, b, 'nomComplet'));
                state.fetchStatus = 'success';
            } else {
                console.error("fetchChauffeur payload is not an array:", action.payload);
                state.chauffeurs = [];
                state.fetchStatus = 'error';
            }
        }).addCase(fetchChauffeur.pending, (state, action) => {
            state.fetchStatus = 'loading';

        }).addCase(fetchChauffeur.rejected, (state, action) => {

            state.fetchStatus = 'error';

        });
    }


});
export const { addChauffeur } = chauffeurSlice.actions;
export default chauffeurSlice;